var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlarm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_816_6613",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_816_6613)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99997 14.3334C7.21364 14.3334 6.47692 14.1847 5.78981 13.8873C5.10258 13.5898 4.50342 13.1856 3.99231 12.6744C3.48119 12.1633 3.07692 11.5642 2.77947 10.8769C2.48203 10.1898 2.33331 9.45312 2.33331 8.66678C2.33331 7.88045 2.48203 7.14373 2.77947 6.45662C3.07692 5.76939 3.48119 5.17023 3.99231 4.65911C4.50342 4.148 5.10258 3.74373 5.78981 3.44628C6.47692 3.14884 7.21364 3.00012 7.99997 3.00012C8.78631 3.00012 9.52303 3.14884 10.2101 3.44628C10.8974 3.74373 11.4965 4.148 12.0076 4.65911C12.5188 5.17023 12.923 5.76939 13.2205 6.45662C13.5179 7.14373 13.6666 7.88045 13.6666 8.66678C13.6666 9.45312 13.5179 10.1898 13.2205 10.8769C12.923 11.5642 12.5188 12.1633 12.0076 12.6744C11.4965 13.1856 10.8974 13.5898 10.2101 13.8873C9.52303 14.1847 8.78631 14.3334 7.99997 14.3334ZM9.98197 11.3514L10.6846 10.6488L8.49997 8.46428V5.33345H7.49997V8.86928L9.98197 11.3514ZM3.83581 1.92578L4.53847 2.62828L1.96147 5.20528L1.25897 4.50262L3.83581 1.92578ZM12.1641 1.92578L14.741 4.50262L14.0385 5.20528L11.4615 2.62828L12.1641 1.92578ZM7.99997 13.3334C9.29575 13.3334 10.3975 12.8796 11.3051 11.9719C12.2128 11.0643 12.6666 9.96256 12.6666 8.66678C12.6666 7.371 12.2128 6.26928 11.3051 5.36162C10.3975 4.45395 9.29575 4.00012 7.99997 4.00012C6.70419 4.00012 5.60247 4.45395 4.69481 5.36162C3.78714 6.26928 3.33331 7.371 3.33331 8.66678C3.33331 9.96256 3.78714 11.0643 4.69481 11.9719C5.60247 12.8796 6.70419 13.3334 7.99997 13.3334Z",
    fill: "#495054"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarm);
export default __webpack_public_path__ + "static/media/alarm.4b483222fe73b47fd1bd614e5b2895ba.svg";
export { ForwardRef as ReactComponent };